import { MathOperation } from '../../PredefinedConfig/Common/Enums';
export const shortcutOperationList = [
    MathOperation.Add,
    MathOperation.Subtract,
    MathOperation.Multiply,
    MathOperation.Divide,
];
